import {
  Box,
  Button,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import {
  setUserBusyMessage,
  setUserBusyModel,
} from "../../../../../services/store/slice/CallSlice";
import { useDispatch, useSelector } from "react-redux";
import { sendMessageToHub } from "../../../../../services/signalRService/signalRService";
import hiEmote from "../../../../../../assets/images/hiEmote.gif";

const UserBusyModel = () => {
  const dispatch = useDispatch();
  const { userBusyModel, userBusyMessage, toCallingPersonName } = useSelector(
    (state) => state.call,
  );
  const chatId = localStorage.getItem("chatId");
  const senderId = localStorage.getItem("user_id");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    height: 300,
    bgcolor: "background.paper",
    pt: 1,
    borderRadius: "10px",
    // pb: 4,
    pr: 3,
    pl: 3,
  };

  // sending the msg
  const handleSendBtn = async () => {
    const messageParams = {
      conversationId: parseInt(chatId),
      SenderId: parseInt(senderId),
      MessageContent: userBusyMessage,
      IsRead: false,
      CreatedBy: parseInt(senderId),
    };
    await sendMessageToHub([messageParams], "tempID");
    dispatch(setUserBusyModel(false));
    dispatch(setUserBusyMessage("Give me a call when you're back !"));
  };

  return (
    <Modal open={userBusyModel}>
      <Box sx={style}>
        {/* Close Button */}
        <Box
          sx={{
            width: "100%",
            height: "auto",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "right",
          }}
        >
          <IconButton>
            <CloseIcon
              sx={{
                color: "black",
                cursor: "pointer",
              }}
              onClick={() => dispatch(setUserBusyModel(false))}
            />
          </IconButton>
        </Box>
        <Box
          sx={{
            position: "absolute",
            width: "90%",
            height: "70%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Emoji */}
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <img width={"120px"} src={hiEmote} alt="Waving Hand Emote" />
          </Box>

          {/* Unavailable Text */}
          <Box sx={{ mt: 1, display: "flex", justifyContent: "center" }}>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "poppins",
              }}
            >
              {toCallingPersonName} is unavailable.
            </Typography>
          </Box>

          {/* Textfield message & send Btn */}
          <Box
            sx={{
              // backgroundColor: "green",
              width: "290px",

              mt: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
            }}
          >
            <TextField
              variant="outlined"
              size="large"
              fullWidth
              value={userBusyMessage}
              onChange={(e) => dispatch(setUserBusyMessage(e.target.value))}
              multiline
              minRows={1}
              sx={{
                margin: 0,
                padding: 0,
                "& .MuiOutlinedInput-root": {
                  padding: 0,
                  "& fieldset": { borderColor: "#085F99" },
                  "&:hover fieldset": { borderColor: "#085F99" },
                  "&.Mui-focused fieldset": { borderColor: "#085F99" },
                },
                "& .MuiInputBase-root": { padding: 0 },
                "& .MuiOutlinedInput-input": { padding: 0.8, margin: 0 },
              }}
            />

            <Box
              sx={{
                width: "50px",
                height: "44px",
                backgroundColor: "#085F99",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                overflow: "hidden",
              }}
              onClick={handleSendBtn}
            >
              <IconButton sx={{ color: "white", p: 0 }}>
                <SendIcon sx={{ fontSize: "20px" }} />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default UserBusyModel;
